import { generateZodObjectFromPaths } from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_UnifiedLegalComfort3BasicRolandDe } from '@flows/insurance/schemas'

const legal_quote = (params: StepConfigParams) =>
  ({
    schema: generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('coverage_legal_comfort_3_criminal_roland_de_enabled')]:
        BaseSchema_UnifiedLegalComfort3BasicRolandDe.shape
          .coverage_legal_comfort_3_criminal_roland_de_enabled,
      [params.helperFunctions.getParamPath('coverage_legal_comfort_3_tenant_roland_de_enabled')]:
        BaseSchema_UnifiedLegalComfort3BasicRolandDe.shape
          .coverage_legal_comfort_3_tenant_roland_de_enabled,
    }),
    stepContent: [
      {
        type: 'customComponent',
        name: 'QuoteStep',
        props: {
          product: 'unified_legal_comfort_3_basic_roland_de',
        },
        inputs: [],
        outputs: [],
      },
    ],

    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: 'unified_legal_comfort_3_basic_roland_de',
        },
        inputs: [],
        outputs: [],
      },
    },

    nextStep: 'emailAndName',
    subFlow: params.subFlow,

    showOrderSummary: true,
    showSaveQuote: true,
    nonStickyFooter: true,
  }) as const satisfies AnyStepConfiguration

export default legal_quote
